import React from 'react';
import clsx from 'clsx';

import styles from './SectionTitle.module.scss';

interface SectionTitleProps {
  hero?: boolean;
  fontColor?: string;
}

const SectionTitle = ({
  children,
  hero,
  fontColor,
}: React.PropsWithChildren<SectionTitleProps>): React.ReactElement => {
  return (
    <h3
      className={clsx(styles.title, { [styles.hero]: hero })}
      style={{
        color: hero ? 'white' : fontColor,
      }}
    >
      {children}
    </h3>
  );
};

export default SectionTitle;
